/* eslint-disable import/no-unresolved */
import React from "react";
import ShopPaymentCheckout from "components/pages/user/checkout/shopCheckout/payment-page";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopPaymentCheckout = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <ShopPaymentCheckout {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopPaymentCheckout);
